import { Box } from "@chakra-ui/react";

type Props = {
  label: string;
};

export function EnergyLabel({ label }: Props) {
  return (
    <Box
      _after={{
        content: '""',
        display: "block",
        w: 0,
        h: 0,
        border: "16px solid transparent",
        borderLeftColor: `labels.${label}`,
        position: "absolute",
        top: "0%",
        right: "-32px",
      }}
      bg={`labels.${label}`}
      borderRadius="2px 0 0 2px"
      color="white"
      flexShrink={0}
      fontSize="1rem"
      fontWeight="500"
      h={8}
      lineHeight={2}
      mr={4}
      pos="relative"
      textAlign="center"
      w={14}
    >
      <span translate="no">{label}</span>
    </Box>
  );
}
